export const VIDEO_CALLS_ARE_SUPPORTED = !!window.RTCPeerConnection;
